import React from "react";
import {
  Box,
  Grid,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  IconButton,
  InputAdornment,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomDateRangePicker from "../DatePicker/CustomDateRangeCalendar";
import ExcelImg from "../Assets/images/Excel.jpg";
import PdfImg from "../Assets/images/pdf.png";

const FilterHeader = ({
  total = 0,
  searchType,
  setSearchType,
  searchTerm,
  setSearchTerm,
  dateRange,
  setDateRange,
  downloadExcel,
  downloadPDF,
  searchOptions = [],
  // Conditional display controls
  showDatePicker = false,
  showExcel = false,
  showPDF = false,
}) => {
  return (
    <Box
      sx={{
        mt: 2,
        mb: 3,
        p: 2,
        backgroundColor: "#fff",
        borderRadius: 2,
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        width: "100%",
      }}
    >
      <Grid
        container
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
      >
        {/* 🧮 Total Count — always on left */}
        <Grid item xs={12} sm="auto">
          <Typography
            variant="subtitle1"
            fontWeight="bold"
            sx={{ textAlign: { xs: "center", sm: "left" } }}
          >
            Total: <span style={{ color: "#1976d2" }}>{total}</span>
          </Typography>
        </Grid>

        {/* 🔍 Filters Section — aligned to right */}
        <Grid
          item
          xs={12}
          sm
          sx={{
            display: "flex",
            justifyContent: { xs: "flex-start", sm: "flex-end" },
          }}
        >
          <Grid
            container
            spacing={2}
            alignItems="center"
            justifyContent={{ xs: "flex-start", sm: "flex-end" }}
            sx={{
              flexWrap: "wrap",
              maxWidth: "100%",
            }}
          >
            {/* 🔽 Search Type */}
            <Grid item xs={12} sm={6} md="auto">
              <FormControl size="small" fullWidth>
                <InputLabel>Search By</InputLabel>
                <Select
                  value={searchType}
                  onChange={(e) => setSearchType(e.target.value)}
                  label="Search By"
                >
                  {searchOptions.map((opt) => (
                    <MenuItem key={opt.value} value={opt.value}>
                      {opt.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* 🔍 Search Box */}
            <Grid item xs={12} sm={6} md="auto">
              <TextField
                fullWidth
                size="small"
                label="Search"
                variant="outlined"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                InputProps={{
                  endAdornment: searchTerm && (
                    <InputAdornment position="end">
                      <IconButton
                        size="small"
                        onClick={() => setSearchTerm("")}
                        edge="end"
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            {/* 📅 Date Range */}
            {showDatePicker && (
              <Grid item xs={4} sm={2} md="auto">
                <CustomDateRangePicker
                  value={dateRange}
                  onChange={setDateRange}
                />
              </Grid>
            )}

            {/* 📊 Excel Download */}
            {showExcel && (
              <Grid item xs={2} sm={1} md="auto">
                <IconButton
                  onClick={downloadExcel}
                  title="Download Excel"
                  sx={{ p: 0, borderRadius: "8px", overflow: "hidden" }}
                >
                  <Box
                    component="img"
                    src={ExcelImg}
                    alt="Download Excel"
                    sx={{
                      width: 36,
                      height: 36,
                      objectFit: "cover",
                      borderRadius: "8px",
                      transition: "transform 0.2s ease",
                      "&:hover": { transform: "scale(1.1)" },
                    }}
                  />
                </IconButton>
              </Grid>
            )}

            {/* 📄 PDF Download */}
            {showPDF && (
              <Grid item xs={2} sm={2} md="auto">
                <IconButton
                  onClick={downloadPDF}
                  title="Download PDF"
                  sx={{ p: 0, borderRadius: "8px", overflow: "hidden" }}
                >
                  <Box
                    component="img"
                    src={PdfImg}
                    alt="Download PDF"
                    sx={{
                      width: 36,
                      height: 36,
                      objectFit: "cover",
                      borderRadius: "8px",
                      transition: "transform 0.2s ease",
                      "&:hover": { transform: "scale(1.1)" },
                    }}
                  />
                </IconButton>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default FilterHeader;
